









































import Component, { mixins } from "vue-class-component";
import RecurrenceUtils from "../utils/recurrenceUtils";
import { RecurrenceRule, Destinataire, Abonnement } from "@/shared/Recurrence";
import ErrorMixin from "@/mixins/errorMixins";
import RapportSelection from "@/components/rapportSelection.vue";
import RegleRecurrence from "@/config/recurrences/recurrencesRegle.vue";
import DestinationRecurrence from "@/config/recurrences/recurrencesDestinations.vue";
import AbonnementsRecurrences from "@/config/recurrences/recurrencesAbonnements.vue";
import RuleAdderFec from "@/config/recurrences/ruleAdderFec.vue";
import DestinationAdder from "@/config/recurrences/destinationAdder.vue";

@Component({
  components: {
    RapportSelection,
    RegleRecurrence,
    DestinationRecurrence,
    AbonnementsRecurrences,
    RuleAdderFec,
    DestinationAdder,
  },
})
export default class RecurrencesFec extends mixins(ErrorMixin) {
  /*
      variables permettants de choisir quel onglet activer pour les v-tabs
      */
  public tab = 0;
  /*
      variables permettants de stocker les différentes règles, destinaires et abonnements déjà existants
      */
  public listRules = new Array();
  public listDests = new Array();
  public listAbos = new Array();
  public restaurantID: string = "0";

  /*
      variable permettant de relier les différents règles avec les destinataires en fonction des abonnements
      */
  public rulesOfDest: any = {};

  public RuleAdderFec = RuleAdderFec;
  public DestinationAdderComponent = DestinationAdder;

  public mounted() {
    RecurrenceUtils.getAllRules().then((rules: any) => {
      this.listRules = rules.filter((rule: any) => {
        return rule.fabricExportableClassName === "FabricExportableFec";
      });
    });
    RecurrenceUtils.getAllAbos().then((abos: any) => {
      this.listAbos = abos.filter((abo: any) => {
        return (
          abo.regleExportable.fabricExportableClassName ===
          "FabricExportableFec"
        );
      });
    });
    RecurrenceUtils.getAllDests().then((dest: any) => {
      this.listDests = dest;
      this.listDests.forEach((destinataire: any) => {
        RecurrenceUtils.getRulesOfDest(destinataire).then((mesabos: any) => {
          if (mesabos.length > 0) {
            destinataire.$abonnements = mesabos.filter(
              (rule: any) =>
                rule.fabricExportableClassName === "FabricExportableFec"
            );
          }
        });
      });
    });
  }
  /*
   * Méthode permettant de supprimer une règle
   */
  public deleteRule(rule: RecurrenceRule) {
    this.listRules = this.listRules.filter(
      (re: RecurrenceRule) => re.id !== rule.id
    );
  }
  /**
   *
   * @param abo
   */
  public async addDest(abo: Destinataire) {
    this.listDests.push(abo);
  }
  /*
   * Méthode permettant de supprimer une règle
   */
  public deleteDest(rule: Destinataire) {
    this.listDests = this.listDests.filter(
      (re: Destinataire) => re.id !== rule.id
    );
  }
  /**
   *
   * @param abo
   */
  public async addRule(abo: RecurrenceRule) {
    this.listRules.push(abo);
  }
  /*
   * Méthode permettant d'ajouter un nouvel abonnement
   */
  public async addAbo(abo: Abonnement) {
    this.listAbos.push(abo);
  }
  /*
   * Méthode permettant de supprimer un abonnement
   */
  public async deleteAbo(abonnement: Abonnement) {
    // console.log(abonnement);
    const ruleId = abonnement.regleExportable.id;
    const dest = abonnement.regleDestinations;
    dest.forEach((destination: any) => {
      RecurrenceUtils.unsubscribeAbo(ruleId, destination.id).then(
        (response: any) => {
          RecurrenceUtils.getAllAbos().then((abos: any) => {
            this.listAbos = abos;
          });
          this.listDests.forEach((destinataire: any) => {
            RecurrenceUtils.getRulesOfDest(destinataire).then(
              (mesabos: any) => {
                if (mesabos.length > 0) {
                  destinataire.$abonnements = mesabos;
                }
              }
            );
          });
        }
      );
      RecurrenceUtils.deleteAbo(abonnement.id).then((response: any) => {
        this.setSuccess(this.$t("supprAbo").toString());
      });
    });
  }

  public unsubscribe(evt: any) {
    RecurrenceUtils.unsubscribeAbo(evt.ruleid, evt.dest.id).then(
      (response: any) => {
        this.loadDestinataires();
        RecurrenceUtils.getAllAbos().then((abos: any) => {
          this.listAbos = abos;
        });
        this.setSuccess(this.$t("supprAbo").toString());
      }
    );
  }

  public backToFec() {
    this.$router.push(`/fec`);
  }

  private loadDestinataires() {
    RecurrenceUtils.getAllDests().then((dest: any) => {
      this.listDests = dest;
      this.listDests.forEach((destinataire: any) => {
        RecurrenceUtils.getRulesOfDest(destinataire).then((mesabos: any) => {
          if (mesabos.length > 0) {
            destinataire.$abonnements = mesabos;
          }
        });
      });
    });
  }

  get fecRestaurantId(): number {
    return this.$store.getters["config/fecRestaurantId"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }
}
